import React, { useContext, useEffect, useState, forwardRef, useCallback } from 'react';
import { throttle } from 'lodash';
import { Modal, Button, Form, Col, Row, FloatingLabel } from 'react-bootstrap';
import Select, { createFilter } from 'react-select';
import AsyncSelect from 'react-select/async';
import CustomOption from '../../utils/Elements/CustomOption';
import CompaniesNav from '../../pages/Dashboard/components/CompaniesNav';
import { CountContext, ParentContext, CompanyContext, EmployeeContext, StateContext } from '../../layouts/Dashboard/LayoutDashboard';
import { jwtDecode } from 'jwt-decode';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
//see this for date formats: https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
//see this for date picker: https://reactdatepicker.com/

import '../Pages.css';

export const OrderSearch = ({ showModal, closeModal, orderFilters, setOrderFilters }) => {
  const api = process.env.REACT_APP_API_ENDPOINT;
  const salesRepsEndpoint = `${api}/v1/individuals/salesreps`;
  //const contactsEndpoint = `${api}/v1/individuals/list`;
  const parentsSearch = `${api}/v1/parents/search`;
  const companySearch = `${api}/v1/companies/search`;
  const individualsSearch = `${api}/v1/individuals/search`;

  const { allParents, setAllParents, selectedParentID, setSelectedParentID} = useContext(ParentContext);
  const { allCompanies, setAllCompanies, selectedCompanyID, setSelectedCompanyID, setSelectedCompanyParentID } = useContext(CompanyContext);
  const { allEmployees } = useContext(EmployeeContext);
  const [filterTotal, setFilterTotal] = useState(0);
  const [filterMessage, setFilterMessage] = useState("");
  const [contact, setContact] = useState(null);
  const [orderFor, setOrderFor] = useState(null);
  const [salesReps, setSalesReps] = useState([]);
  const [salesRep, setSalesRep] = useState(null);
  const [advertiserChange, setAdvertiserChange] = useState("");
  const [sizeChange, setSizeChange] = useState("");
  const [designChange, setDesignChange] = useState("");
  const [shippingChange, setShippingChange] = useState("");
  const [descriptionChange, setDescriptionChange] = useState("");
  const [reorderChange, setReorderChange] = useState("");
  const [partChange, setPartChange] = useState("");
  const [unitChange, setUnitChange] = useState("");
  const [referencesChange, setReferencesChange] = useState("");
  const [geoPathChange, setGeoPathChange] = useState("");
  const [invoiceChange, setInvoiceChange] = useState("");
  const [salesRepsLoading, setSalesRepsLoading] = useState(false);
  const [productChange, setProduct] = useState("");
  const [orderChange, setOrder] = useState(0);

  //the remaining filters are static
  const defaulOrderType = { label: "All", value: 0 };
  const [orderType, setOrderType] = useState(defaulOrderType);

  const [dateTypes] = useState([
    { value: 0, label: "Order Date" },
    { value: 1, label: "Ship Date" },
    { value: 2, label: "Delivery Date" },
    { value: 3, label: "Post Date" },
    { value: 4, label: "Proof Approved Date" },
  ]);
  const [dateType, setDateType] = useState(dateTypes[0]);
  const [statuses] = useState([
    { value: -1, label: "All Statuses" },
    { value: 0, label: "Approved - Holding Print" },
    { value: 1, label: "Art Accepted" },
    { value: 2, label: "Art Hold" },
    { value: 3, label: "Art Needed" },
    { value: 4, label: "Art Qualification" },
    { value: 5, label: "Art Uploaded" },
    { value: 6, label: "Art Uploading" },
    { value: 7, label: "Audit Hold" },
    { value: 8, label: "Awaiting Prepayment" },
    { value: 9, label: "Awaiting Reorder" },
    { value: 10, label: "Canceled" },
    { value: 11, label: "CDPReserved" },
    { value: 12, label: "CDPReserving" },
    { value: 13, label: "Cluster Processing" },
    { value: 14, label: "Cluster Production" },
    { value: 15, label: "Customer Approval" },
    { value: 16, label: "Delivered" },
    { value: 17, label: "Delivery-Exception" },
    { value: 18, label: "Do Not Reprint" },
    { value: 19, label: "Download Completed" },
    { value: 20, label: "File Verification" },
    { value: 21, label: "File Verify Error" },
    { value: 22, label: "Hold For Review" },
    { value: 23, label: "Invoiced" },
    { value: 24, label: "Mass Order Ready" },
    { value: 25, label: "Paid" },
    { value: 26, label: "Paneling" },
    { value: 27, label: "Post Press" },
    { value: 28, label: "Prepress" },
    { value: 29, label: "Print" },
    { value: 30, label: "Print Ready" },
    { value: 31, label: "Ready For Download" },
    { value: 32, label: "ReadyForCDPPrep" },
    { value: 33, label: "Re-Order" },
    { value: 34, label: "Schedule Error" },
    { value: 35, label: "Send Proof" },
    { value: 36, label: "Shipped" },
    { value: 37, label: "Vinyl QC" },
    { value: 38, label: "Web Order" },
  ]);

  const [status, setStatus] = useState(statuses[0]);

  const [dateRanges] = useState([
    //{ value: 0, label: "Upcoming" },
    { value: 0, label: (<><span title={"All Dates prior to 7 days from now."}>Upcoming</span></>) },
    { value: 1, label: "Today" },
    { value: 2, label: "Next 7 Days" },
    { value: 3, label: "Next 30 Days" },
    { value: 4, label: "Last 7 Days" },
    { value: 5, label: "Last 30 Days" },
    { value: 6, label: "Custom" },
    { value: 7, label: "All" },
  ]);
  const defaultDateRange = 0;
  const customDateRange = 6;
  const allDateRange = 7;
  const [dateRange, setDateRange] = useState(dateRanges[defaultDateRange]);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [customDatesDisabled, setCustomDatesDisabled] = useState(true);
  
  const getStoredToken = () => {
    return localStorage.getItem('token');
  };
  const storedToken = getStoredToken();

  //set filters exit modal
  const viewFilters = () => {
    const updatedFilters = {
      parentId: selectedParentID,
      companyId: selectedCompanyID,
      orderFor: orderFor ? orderFor.value : 0,
      contactId: contact ? contact.value : 0,
      contactName: contact ? contact.label : "",
      salesRepId: salesRep ? salesRep.value : 0,
      orderType: orderType.value,
      dateType: dateType ? dateType.label : dateTypes[0].label,
      status: status?.value ?? '',
      dateRange: dateRange.value,
      dateRangeStart: fromDate,
      dateRangeEnd: toDate,
      filterTotal: filterTotal,
      applyFilter: true,
      advertiser: advertiserChange,
      size: sizeChange,
      design: designChange,
      shipping: shippingChange,
      description: descriptionChange,
      reorder: reorderChange,
      part: partChange,
      unit: unitChange,
      references: referencesChange,
      geopathid: geoPathChange,
      invoice: invoiceChange,
      product: productChange,
      order: orderChange
    };

    setOrderFilters(updatedFilters);
    closeModal();
  };

  //reset filters
  const resetFilters = () => {
    
    //setParent(parents.find(x => x.value === (selectedCompanyParentID ? selectedCompanyParentID : selectedParentID)));
    //setCompany(companies.find(x => x.value === selectedCompanyID));

    setContact(null);
    setSalesRep(null);

    const identity = jwtDecode(storedToken);

    setOrderFor(allEmployees.find(x => x.data === identity.sub.toUpperCase()));
    setDateType(dateTypes[0]);
    setStatus(statuses[0]);
    setDateRange(dateRanges[defaultDateRange]);
    //setApplyFilter(false);
  };

  const handleContactChange = (value) => {
    setContact(value);
  };
  const handleSalesRepChange = (value) => {
    setSalesRep(value);
  };
  const handleStatusChange = (status) => {
    console.log("status: ", status);
    console.log("status value: ", status.value);
    setStatus(statuses[status.value]);
    console.log("status: ", status);
  };
  const handleDateTypeChange = (value) => {
    setDateType(value);
  };
  const handleDateRangeChange = (value) => {
    setDateRange(value);
  };
  const handleFromDateChange = (value) => {
    setFromDate(value);
  };
  const handleToDateChange = (value) => {
    setToDate(value);
  };
  const handleOrderChange = (value) => {
    setOrder(value);
  };

  const handleProductChange = (value) => {
    setProduct(value);
  };


  const handleAdvertiserChange = useCallback(
    throttle((value) => {
      setAdvertiserChange(value);
    }, 100),
    []
  );

  const handleSizeChange = useCallback(
    throttle((value) => {
      setSizeChange(value);
    }, 100),
    []
  );

  const handleDesignChange = useCallback(
    throttle((value) => {
      setDesignChange(value);
    }, 100),
    []
  );

  const handleShippingChange = useCallback(
    throttle((value) => {
      setShippingChange(value);
    }, 100),
    []
  );

  const handleDescriptionChange = useCallback(
    throttle((value) => {
      setDescriptionChange(value);
    }, 100),
    []
  );

  const handleReorderChange = useCallback(
    throttle((value) => {
      setReorderChange(value);
    }, 100),
    []
  );

  const handlePartChange = useCallback(
    throttle((value) => {
      setPartChange(value);
    }, 100),
    []
  );

  const handleUnitChange = useCallback(
    throttle((value) => {
      setUnitChange(value);
    }, 100),
    []
  );

  const handleReferencesChange = useCallback(
    throttle((value) => {
      setReferencesChange(value);
    }, 100),
    []
  );

  const handleGeoPathChange = useCallback(
    throttle((value) => {
      setGeoPathChange(value);
    }, 100),
    []
  );

  const handleInvoiceChange = useCallback(
    throttle((value) => {
      setInvoiceChange(value);
    }, 100),
    []
  );

  const fetchSalesReps = async () => {

    if (storedToken) {

      try {
        setSalesRepsLoading(true);

        const pid = selectedParentID ? selectedParentID : 0;
        const cid = selectedCompanyID ? selectedCompanyID : 0;

        const response = await fetch(salesRepsEndpoint + `?parentId=${pid}&companyId=${cid}`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${storedToken}`,
            'Content-Type': 'application/json',
          }
        });
        if (response.ok) {
          const data = await response.json();
          //data.unshift(defaultSalesRep);
          setSalesReps(data);
          setSalesRepsLoading(false);

        } else {
          setSalesReps([]);
          setSalesRepsLoading(false);
          console.error('Order Search: Failed to fetch sales reps');
        }

      } catch (error) {
        setSalesReps([]);
        setSalesRepsLoading(false);
        console.error('Order Search: Failed to fetch sales reps');
      }
    }
  };

  const getDatesFromRange = (range) => {

    let f = fromDate;
    let t = toDate;

    switch (range) {
      case 0: //upcoming
        f = formatDate(new Date('01/01/1980'));
        t = next(7);
        break;
      case 1: //Today
        f = today();
        t = f;
        break;
      case 2: //Next 7 Days
        f = today();
        t = next(7);
        break;
      case 3: //Next 30 Days
        f = today();
        t = next(30);
        break;
      case 4: //Last 7 Days
        f = last(7);
        t = today();
        break;
      case 5: //Last 30 Days
        f = last(30);
        t = today();
        break;
      case customDateRange: //Custom
      case allDateRange: //All
      default:
        break;
    }

    setFromDate(f);
    setToDate(t);
    setCustomDatesDisabled(range !== customDateRange);

  };

  useEffect(() => {
    getDatesFromRange(dateRange.value);
  }, [dateRange]);
      
  useEffect(() => {
    fetchSalesReps();

  }, [selectedParentID, selectedCompanyID]);

 //open modal initializations
  useEffect(() => {
    if (showModal && storedToken) {

      if (orderFilters.contactId !== 0) {
        setContact({ label: orderFilters.contactName, value: orderFilters.contactId });
      } else {
        setContact(null);
      }
      const identity = jwtDecode(storedToken);
      if (orderFilters.orderFor === 0) {
        setOrderFor(null);
      } else if (orderFilters.orderFor === -1) { //current user
        setOrderFor(allEmployees.find(x => x.data === identity.sub.toUpperCase()));
      } else {
        setOrderFor(allEmployees.find(x => x.value === orderFilters.orderFor));
      }
      setSalesRep(salesReps.find(x => x.value === orderFilters.salesRepId));
      setStatus(statuses.find(x => x.value === orderFilters.status));
      setDateType(dateTypes[orderFilters.dateType]);
      setDateRange(dateRanges[orderFilters.dateRange]);
    }

  }, [showModal]);

  useEffect(() => {
    let count = 0;
    const identity = jwtDecode(storedToken);
    if (!orderFor || orderFor.data !== identity.sub.toUpperCase()) count += 1;
    if (contact && contact.value !== 0) count += 1;
    if (salesRep && salesRep.value !== 0) count += 1;
    if (orderType && orderType.value !== 0) count += 1;
    if (status && status.value !== 0) count += 1;
    if (dateType && dateType.value !== 0) count += 1;
    if (dateRange.value !== defaultDateRange) count += 1;
    //count += 1;

    setFilterTotal(count);
  }, [contact, salesRep, orderFor, orderType, status, dateType, dateRange]);

  useEffect(() => {
    setFilterMessage(` Search for lines from among the last 5 years of history ${filterTotal} filters applied`);
    
  }, [filterTotal]);

  const formatDate = (dt) => {
    dt.setHours(0, 0, 0, 0);
    return dt;
  };

  const today = () => { return formatDate(new Date()) };

  const last = (days) => {
    var dt = new Date();
    dt.setDate(dt.getDate() - days);
    return formatDate(dt);
  };

  const next = (days) => {
    var dt = new Date();
    dt.setDate(dt.getDate() + days);
    return formatDate(dt);
  };

  const loadParentOptions = async (searchterm) => {

    let results = [];

    const response = await fetch(parentsSearch + `?searchterm=${searchterm}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${storedToken}`,
        'Content-Type': 'application/json'
      }
    });
    if (response.ok) {
      const data = await response.json();
      results = data.results;
    }

    return results;
  };

  const loadCompanyOptions = async (searchterm) => {

    let results = [];
    let parentid = selectedParentID ? selectedParentID : 0;

    const response = await fetch(companySearch + `?searchterm=${searchterm}&parentid=${parentid}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${storedToken}`,
        'Content-Type': 'application/json'
      }
    });
    if (response.ok) {
      const data = await response.json();
      results = data.results;
    }

    return results;
  };

  const loadIndividualOptions = async (searchterm) => {

    let results = [];
    let parentid = selectedParentID ? selectedParentID : 0;
    let companyid = selectedCompanyID ? selectedCompanyID : 0;
    const response = await fetch(individualsSearch + `?searchterm=${searchterm}&parentid=${parentid}&companyid=${companyid}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${storedToken}`,
        'Content-Type': 'application/json'
      }
    });
    if (response.ok) {
      const data = await response.json();
      results = data.results;
    }

    return results;
  };


  return(
    <Modal show={showModal} onHide={closeModal} dialogClassName="order-filter-modal" backdrop="static">
        <Modal.Header closeButton>
        <Modal.Title>
          Search Filters
          <span className="order-search-title-desc">{filterMessage}</span>
        </Modal.Title>
        </Modal.Header>
      <Modal.Body>
        <Row>
          <Form.Group as={Col} md="6">
            <CompaniesNav dropDownClass="modal-company" companyParentId={selectedParentID} companyId={selectedCompanyID}/>
          </Form.Group>
          <Form.Group as={Col} md="6">
            <FloatingLabel className="floating-select mb-3" label={`Contact`}>
              <AsyncSelect
              id="contact"
                name="individual"
                className="filter-order"
                classNamePrefix="select"
                isClearable={true}
                key={selectedParentID ? selectedParentID : (selectedCompanyID ? selectedCompanyID : 0)} //this is the magic bit that forces the reload
                cacheOptions
                loadOptions={loadIndividualOptions}
                defaultOptions
                value={contact}
                onChange={handleContactChange}
                menuPortalTarget={document.body} //this to fix z-index issue on using react select in a modal
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              />
            </FloatingLabel>
            <FloatingLabel className="floating-select" label={`Date`}>
              <Select
                id='dateType'
                className="filter-order"
                classNamePrefix="select"
                options={dateTypes}
                value={dateType}
                defaultValue={dateTypes[0]}
                onChange={handleDateTypeChange}
              />
            </FloatingLabel>
          </Form.Group>
        </Row>
        {/*row 6*/}
        <Row className='mb-3'>

          <Form.Group as={Col} md="6">
            <FloatingLabel className="floating-select" label={`Status`}>
              <Select
              id='status'
                className="filter-order"
                classNamePrefix="select"
                options={statuses}
                value={status}
                onChange={handleStatusChange}
              />
            </FloatingLabel>
          </Form.Group>

          <Form.Group as={Col} md="6">
            <FloatingLabel className="floating-select" label={`Date Range`}>
              <Select
                id='dateRange'
                className="filter-order"
                classNamePrefix="select"
                options={dateRanges}
                value={dateRange}
                onChange={handleDateRangeChange}
              />
            </FloatingLabel>
          </Form.Group>
        </Row>

        {/*row 4*/}
        <Row className='mb-3'>
          <Form.Group className='mb-3' as={Col} md="6">
            <FloatingLabel className="floating-select" label={`Sales Rep.`}>
              <Select
                id='salesRep'
                className="filter-order"
                classNamePrefix="select"
                options={salesReps}
                value={salesRep}
                isLoading={salesRepsLoading}
                isClearable={true}
                onChange={handleSalesRepChange}
                filterOption={createFilter({ ignoreAccents: false })} //this for performance
                components={{ Option: CustomOption }} //this for performance
              />
            </FloatingLabel>
          </Form.Group>
          <Form.Group as={Col} md="3" >
            <FloatingLabel className="floating-datepicker" label={`From`}>
              <DatePicker
              id='fromDate'
                className="order-search-datepicker"
                dateFormat="E. MM/dd/yyyy"
                disabled={customDatesDisabled}
                selected={fromDate}
                onChange={(date) => handleFromDateChange(date)}
                showIcon
                icon="fa fa-calendar"
                toggleCalendarOnIconClick
              />
            </FloatingLabel>
          </Form.Group>
          <Form.Group as={Col} md="3" >
            <FloatingLabel className="floating-datepicker" label={`To`}>
              <DatePicker
              id='fromDate'
                className="order-search-datepicker"
                dateFormat="E. MM/dd/yyyy"
                disabled={customDatesDisabled}
                selected={toDate}
                onChange={(date) => handleToDateChange(date)}
                minDate={fromDate}
                showIcon
                icon="fa fa-calendar"
                toggleCalendarOnIconClick
              />
            </FloatingLabel>
          </Form.Group>

        </Row>

        <Row className='mb-3'>
          <Form.Group as={Col} md="6">
            <FloatingLabel label={`Order Number`}>
              <Form.Control
                type='number'
                className='order-filter-input'
                id='order'
                placeholder='Order'
                aria-describedby='orderHelpBlock'
                value={orderChange}
                onChange={(e) => handleOrderChange(e.target.value)}
              />
            </FloatingLabel>
            <Form.Text id='orderHelpBlock' muted></Form.Text>
          </Form.Group>
          <Form.Group as={Col} md="6">
            <FloatingLabel label={'Product'}>
              <Form.Control
                type='text'
                className='order-filter-input'
                id='product'
                placeholder="Product"
                aria-describedby='productHelpBlock'
                value={productChange}
                onChange={(e) => handleProductChange(e.target.value)}
              />
            </FloatingLabel>
            <Form.Text id='productHelpBlock' muted></Form.Text>
          </Form.Group>
        </Row>

        <Row className='mb-3'>
          <Form.Group as={Col} md="6">
            <FloatingLabel label={`Advertiser`}>
              <Form.Control
                type='text'
                className='order-filter-input'
                id='advertiser'
                placeholder='Advertiser'
                aria-describedby='advertiserHelpBlock'
                value={advertiserChange}
                onChange={(e) => handleAdvertiserChange(e.target.value)}
              />
            </FloatingLabel>
            <Form.Text id='advertiserHelpBlock' muted></Form.Text>
          </Form.Group>
          <Form.Group as={Col} md="6">
            <FloatingLabel label={`Size (H'h'' x W'w'' or H' x W')`}>
              <Form.Control
                type='text'
                className='order-filter-input'
                id='size'
                placeholder="Size (H'h'' x W'w'' or H' x W')"
                aria-describedby='sizeHelpBlock'
                value={sizeChange}
                onChange={(e) => handleSizeChange(e.target.value)}
              />
            </FloatingLabel>
            <Form.Text id='sizeHelpBlock' muted></Form.Text>
          </Form.Group>
        </Row>

        <Row className='mb-3'>
          <Form.Group as={Col} md="6">
          <FloatingLabel label={`Design`}>
          <Form.Control
              type='text'
              id='design'
              className='order-filter-input'
              placeholder='Design'
              aria-describedby='designHelpBlock'
              value={designChange}
              onChange={(e) => handleDesignChange(e.target.value)}
            />
          </FloatingLabel>
            <Form.Text id='designHelpBlock' muted></Form.Text>
          </Form.Group>
          <Form.Group as={Col} md="6">
          <FloatingLabel label={`Shipping (Address, Track, Sign)`}>
          <Form.Control
              type='text'
              id='shipping'
              className='order-filter-input'
              placeholder='Shipping (Address, Track, Sign)'
              aria-describedby='shippingHelpBlock'
              value={shippingChange}
              onChange={(e) => handleShippingChange(e.target.value)}
            />
          </FloatingLabel>
            <Form.Text id='shippingHelpBlock' muted></Form.Text>
          </Form.Group>
        </Row>

        <Row className='mb-3'>
          <Form.Group as={Col} md="6">
          <FloatingLabel label={`Description`}>
          <Form.Control
              type='text'
              id='description'
              className='order-filter-input'
              placeholder='Description'
              aria-describedby='descriptionHelpBlock'
              value={descriptionChange}
              onChange={(e) => handleDescriptionChange(e.target.value)}
            />
          </FloatingLabel>

            <Form.Text id='descriptionHelpBlock' muted></Form.Text>
          </Form.Group>
          <Form.Group as={Col} md="6">
          <FloatingLabel label={`Reorder, CAP #`}>
          <Form.Control
              type='text'
              id='reorder'
              className='order-filter-input'
              placeholder='Reorder, CAP #'
              aria-describedby='reorderHelpBlock'
              value={reorderChange}
              onChange={(e) => handleReorderChange(e.target.value)}
            />
          </FloatingLabel>
            <Form.Text id='reorderHelpBlock' muted></Form.Text>
          </Form.Group>
        </Row>

        <Row className='mb-3'>
          <Form.Group as={Col} md="6">
          <FloatingLabel label={`Part`}>
          <Form.Control
              type='text'
              id='part'
              className='order-filter-input'
              placeholder='Part'
              aria-describedby='partHelpBlock'
              value={partChange}
              onChange={(e) => handlePartChange(e.target.value)}
            />
          </FloatingLabel>
            <Form.Text id='partHelpBlock' muted></Form.Text>
          </Form.Group>
          <Form.Group as={Col} md="6">
            <FloatingLabel label={`Unit #(s)`}>
              <Form.Control
                type='text'
                id='unit'
                className='order-filter-input'
                placeholder='Unit #(s)'
                aria-describedby='unitHelpBlock'
                value={unitChange}
                onChange={(e) => handleUnitChange(e.target.value)}
              />
            </FloatingLabel>
            <Form.Text id='unitHelpBlock' muted></Form.Text>
          </Form.Group>
        </Row>

        <Row className='mb-3'>
          <Form.Group as={Col} md="6">
          <FloatingLabel label={`References`}>
            <Form.Control
              type='text'
              id='references'
              className='order-filter-input'
              placeholder='References'
              aria-describedby='referencesHelpBlock'
              value={referencesChange}
              onChange={(e) => handleReferencesChange(e.target.value)}
            />
          </FloatingLabel>
            <Form.Text id='referencesHelpBlock' muted></Form.Text>
          </Form.Group>
          <Form.Group as={Col} md="6">
          <FloatingLabel label={`GeopathID(s)`}>
          <Form.Control
              type='text'
              id='geopathid'
              className='order-filter-input'
              placeholder='GeopathID(s)'
              aria-describedby='geopathidHelpBlock'
              value={geoPathChange}
              onChange={(e) => handleGeoPathChange(e.target.value)}
            />
          </FloatingLabel>
            <Form.Text id='geopathidHelpBlock' muted></Form.Text>
          </Form.Group>
        </Row>

        <Row className='mb-3'>
          <Form.Group as={Col} md="6">
            <FloatingLabel label={`Invoice`}>
              <Form.Control
                type='number'
                id='invoice'
                className='order-filter-input'
                placeholder='Invoice'
                aria-describedby='invoiceHelpBlock'
                value={invoiceChange}
                onChange={(e) => handleInvoiceChange(e.target.value)}
              />
            </FloatingLabel>
            <Form.Text id='invoiceHelpBlock' muted></Form.Text>
          </Form.Group>
        </Row>

      </Modal.Body>
        <Modal.Footer>
        <Button variant="secondary" onClick={resetFilters}>
            Reset
          </Button>
        <Button variant="primary" onClick={viewFilters}>
            View
          </Button>
        </Modal.Footer>
      </Modal>
  );
}

/* Advertiser: "VISEN Yellawood"

ArtOtherFees: "0"
​
ArtReceived: "0001-01-01T00:00:00"
​​​
ArtUploadLink: "https://artupload.cgorders.com/artupload.aspx?LineItemUID=1C588CA4-DF69-4409-9098-68552354A0CD&dwf=0&origin=mycircle2"
​​​
BillShipMethod: "C.H. Robinson Freight"
​​​
CAPNumber: ""
​​​
ClientJobRef: ""
​​​
ClientJobRefDetail: ""
​​​
ClientPO: ""
​​​
CompanyName: "Lamar Graphics"
​​​
ContractNum: ""
​​​
DeliveryDisplayLabel: "Target Delivery"
​​​
DeliveryDisplayValue: "2024-08-08 00:00:00"
​​​
Design: "Five Star Backyards"
​​​
FilterByLabel: ""
​​​
FreightCost: 0
​​​
GeoPathIDs: ""
​​​
ImageSize: `13'8" x 47'9"<br />13'8" x 47'9"`
​​​
ImageSizeFinished: `13'8" x 47'9"`
​​​
ImageSizeLive: `13'8" x 47'9"`
​​​
IndividualNameCommissionsContact: "Selena Tate"
​​​
IndividualNameGraphicsContact: "Abby Legendre"
​​​
IndividualNameSalesContact: "Abby Legendre"
​​​
InvoiceLink: ""
​​​
InvoicePaidDate: "0001-01-01T00:00:00"
​​​
IsCancelable: true
​​​
IsEditable: false
​​​
ItemID: 95762117
​​​
LineFreightCost: 0
​​​
LineItemCost: 1801.13
​​​
LineItem_Custom1: ""
​​​
LineItem_Custom2: ""
​​​
LineItem_Custom3: ""
​​​
LineTax: 126.08
​​​
ODUID: "1c588ca4-df69-4409-9098-68552354a0cd"
​​​
OrdHDR_Custom3: ""
​​​
OrderDate: "2024-06-17T13:57:59"
​​​
OrderID: 81884578
​​​
OrderIDLineNum: "81884578-1"
​​​
OrderLineCost: 0
​​​
OrderLineNumber: 1
​​​
OrderLookUp: "https://www.mycircleworks.com/OrderTracking.aspx?orderID=81884578"
​​​
OrderStatusDescription: "Future Campaign"
​​​
OrderStatusID: 48
​​​
OrderStatusSort: 25
​​​
OrderUID: "2b2d5d6d-0f80-46af-9456-ed0f7ac68914"
​​​
OtherCost: 0
​​​
PMS_Callouts: ""
​​​
PODLink: "https://mycirclegraphics.com/ReportServer2/Pages/ReportViewer.aspx?/MyCircle/PODReport&OrderID=81884578&rs:Format=Excel"
​​​
PODText: ""
​​​
PTInvoiceDate: "0001-01-01T00:00:00"
​​​
PayLink: ""
​​​
PrePressNotes: ""
​​​
Printed: "0001-01-01T00:00:00"
​​​
ProductDescription: "Visen Backlit Banner-Front/Back Print 15 oz"
​​​
ProductDisplayName: "Visen Backlit Banner-Front/Back Print 15 oz"
​​​
ProductID: 12488
​​​
ProductionMinimumCost: 0
​​​
ProofApproved: "0001-01-01T00:00:00"
​​​
ProofLink: "#view-proof?LineItemUID=1C588CA4-DF69-4409-9098-68552354A0CD"
​​​
ProofLinkJPG: "https://www.mycircleworks.com/ProofPreview.aspx?LineItemUID=D1F63D14-1FB6-4544-9F0F-5580904133CB&ProofType=jpg"
​​​
ProofLinkPDF: "https://www.mycircleworks.com/ProofPreview.aspx?LineItemUID=D1F63D14-1FB6-4544-9F0F-5580904133CB&ProofType=pdf"
​​​
ProofMethod: "Online Proof"
​​​
ProofRejected: "0001-01-01T00:00:00"
​​​
ProofSent: "0001-01-01T00:00:00"
​​​
Qty: 1
​​​
ReOrder: false
​​​
ReOrderLineNumber: 0
​​​
ReorderAllowed: true
​​​
RequiredReceiptDate: "2024-08-08T00:00:00"
​​​
SAPInvoiceNum: 0
​​​
SequenceNum: 0
​​​
ShipDisplayLabel: "Target Ship"
​​​
ShipDisplayValue: "2024-08-08 00:00:00"
​​​
ShipMethodDescription: "C.H. Robinson Freight"
​​​
ShipTo: "Brunner"
​​​
ShipToAddress1: "11 STANWIX ST"
​​​
ShipToAddress2: ""
​​​
ShipToCity: "PITTSBURGH"
​​​
ShipToEmail: "alegendre@lamar.com;state@lamar.com;bholzworth@circlegraphicsonline.com"
​​​
ShipToFax: ""
​​​
ShipToPerson: "Karl Fritzman"
​​​
ShipToPhone: "303-532-2370"
​​​
ShipToState: "PA"
​​​
ShipToZip: "15222-1318"
​​​
Shipped: "0001-01-01T00:00:00"
​​​
ShippedDate: "1900-01-01T00:00:00"
​​​
ShippingCost: 0
​​​
SortPriority: 9
​​​
SortPriorityDate: "2024-08-08T00:00:00"
​​​
TargetShipDate: "2024-08-08T00:00:00"
​​​
Tax: 126.08
​​​
TotalCount: 3
​​​
TotalLineItemCost: 1801.13
​​​
TotalOrderCost: 1927.21
​​​
TotalOrderLines: 3
​​​
TransitTime: 0
​​​
UnitNumbers: "" */